import React from 'react'

const BusinessCardProWifi = (props) => {
    const {title}=props
    return (
        <>
            <div className="card mb-3 mt-2 shadow-sm">
                <div className="m-2 " style={{display:"inline-flex"}}>
                    <p className="card-text overflow-hidden">{title}</p>
                </div>
            </div>
        </>
    )
}

export default BusinessCardProWifi;
